import Vue from "vue";
import Router from "vue-router";
import auth from "./auth";

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/login', name: 'login', component: () => import('./views/login-form.vue'), meta: { noAuth: true } },
    { path: '/home', name: 'home', component: () => import('./views/home-page.vue') },
    { path: '/gth', name: 'gth', component: () => import('./views/CustomerPage.vue') },
    { path: '/clue', name: 'clue', component: () => import('./views/CluePage.vue') },
    { path: '/personGroup', name: 'personGroup', component: () => import('./views/PersonGroupPage.vue') },
    { path: '/foreignTrade', name: 'foreignTrade', component: () => import('./views/personGroup/ForeignTrade.vue') },
    { path: '/foreignTradeTwo', name: 'foreignTradeTwo', component: () => import('./views/personGroup/ForeignTradeTwo.vue') },
    { path: '/bill', name: 'bill', component: () => import('./views/BillPage.vue') },
    { path: '/kefu', name: 'kefu', component: () => import('./views/KeFuPage.vue') },
    { path: '/custom-service', name: 'customService', component: () => import('./views/custom-service-page.vue') },
    { path: '/batch-query', name: 'batchQuery', component: () => import('./views/BatchQueryPage.vue') },
    { path: '/', redirect: '/home' },
    { path: '*', redirect: '/home' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.noAuth)) { next() }
  else if (!auth.loggedIn()) { next({ path: '/login', query: { redirect: to.fullPath } }) }
  else { next() }
});

export default router;
